import React from 'react'
import useOperation from '../hooks/use-operation'
import { useConstrainable } from '@morningtrain/react-filters'

export default function SetConstrainableOnOperation () {
  const operation = useOperation()
  const constrainable = useConstrainable()

  React.useEffect(() => {
    operation.constrainable = constrainable
  }, [operation, constrainable])

  return null
}
